<template>
  <section class="banner__area banner__area-d pb-10">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12" v-if="adsByType[4]">
          <div class="banner__item p-relative w-img mb-30">
            <div class="banner__img">
              <router-link to="/shop">
                <img :src="adsByType[4].image_url" :alt="adsByType[4].title" />
              </router-link>
            </div>
            <div class="banner__content">
              <span>{{ adsByType[4].tag }}</span>
              <h6><router-link to="/shop">{{ adsByType[4].title }}</router-link></h6>
              <p>{{ adsByType[4].text }}</p>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12" v-if="adsByType[5]">
          <div class="banner__item p-relative w-img mb-30">
            <div class="banner__img">
              <router-link to="/shop">
                <img :src="adsByType[5].image_url" :alt="adsByType[5].title" />
              </router-link>
            </div>
            <div class="banner__content">
              <span>{{ adsByType[5].tag }}</span>
              <h6><router-link to="/shop">{{ adsByType[5].title }}</router-link></h6>
              <p>{{ adsByType[5].text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    ads: {
      type: Array,
      required: true,
    },

  },
  computed: {
    adsByType() {
      // Group ads by their add_type
      const groupedAds = {};
      this.ads.forEach(ad => {
        if ([4,5].includes(ad.add_type)) {
          groupedAds[ad.add_type] = ad;
        }
      });
      return groupedAds;
    },
  },

};
</script>

<style scoped>
/* Add your styles here */
</style>
